import { lazy } from 'react'
import MyTricksSettings from '../../views/pages/MyTricks/MyTricksSettings'
const Home = lazy(() => import('../../views/pages/Home'))
const TopTen = lazy(() => import('../../views/pages/Home/topTen'))
const Tricks = lazy(() => import('../../views/pages/Home/Tricks'))
const MyTricks = lazy(() => import('../../views/pages/MyTricks'))
const MyTrickProfit = lazy(() => import('../../views/pages/MyTrickProfit'))
const TradeHistory = lazy(() => import('../../views/pages/TradeHistory'))
const OrderHistory = lazy(() => import('../../views/pages/OrderHistory'))
const ReferAndEarn = lazy(() => import('../../views/pages/ReferAndEarn'))
const RewardHistory = lazy(() => import('../../views/pages/RewardHistory'))
const MyTeam = lazy(() => import('../../views/pages/MyTeam'))
const DirectReferrals = lazy(() => import('../../views/pages/MyTeam/DirectReferrals'))
const MyWallet = lazy(() => import('../../views/pages/MyWallet'))
const WalletHistory = lazy(() => import('../../views/pages/MyWallet/WalletHistory'))
const MySubscription = lazy(() => import('../../views/pages/MySubscription'))
const MyTransactions = lazy(() => import('../../views/pages/MySubscription/MyTransactions'))
const AlertsAndNotification = lazy(() => import('../../views/pages/AlertsAndNotification'))
const RobotricUserGuide = lazy(() => import('../../views/pages/RobotricUserGuide'))
const InfoVideos = lazy(() => import('../../views/pages/InfoVideos'))
const JoinWebiner = lazy(() => import('../../views/pages/JoinWebiner'))
const RaiseTicket = lazy(() => import('../../views/pages/RaiseTicket'))
const Faq = lazy(() => import('../../views/pages/my-faq'))
const Logs = lazy(() => import('../../views/pages/Logs'))


const MainDashboardRoutes = [
  {
    path: '/home',
    element: <MyTeam />
  },
  {
    path: '/home/tricks',
    element: <Tricks />
  },
  {
    path: '/top-ten',
    element: <TopTen />
  },
  {
    path: '/my-tricks',
    element: <MyTricks />
  },
  {
    path: '/my-tricks/settings',
    element: <MyTricksSettings />,
  },
  {
    element: <MyTrickProfit />,
    path: '/my-trick-profit',
  },
  {
    element: <TradeHistory/>,
    path: '/trade-history',
  },
  {
    element: <OrderHistory/>,
    path: '/order-history',
  },
  {
    element: <ReferAndEarn/>,
    path: '/refer-and-earn',
  },
  {
    element: <RewardHistory/>,
    path: '/reward-history',
  },
  {
    element: <MyTeam/>,
    path: '/my-team',
  },
  {
    element: <DirectReferrals/>,
    path: '/my-team/direct-referrals',
  },
  {
    element: <MyWallet/>,
    path: '/my-wallet',
  },
  {
    element: <WalletHistory/>,
    path: '/wallet-history',
  },
  {
    element: <MySubscription/>,
    path: '/my-subscription',
  },
  // {
  //   element: <MyTransactions/>,
  //   path: '/my-transactions',
  // },
  // {
  //   element: <AlertsAndNotification/>,
  //   path: '/alerts-and-notification',
  // },
  // {
  //   element: <RobotricUserGuide/>,
  //   path: '/alerts-user-guide',
  // },
  // {
  //   element: <InfoVideos/>,
  //   path: '/info-videos',
  // },
  // {
  //   element: <JoinWebiner/>,
  //   path: '/join-webiner',
  // },
  // {
  //   element: <Faq/>,
  //   path: '/faq',
  // },
  // {
  //   element: <RaiseTicket/>,
  //   path: '/raise-ticket',
  // },
  // {
  //   element: <Logs/>,
  //   path: '/logs',
  // },

 
]

export default MainDashboardRoutes
